import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceHistoryModel } from 'src/app/models/InvoiceHistoryModels';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { InvoiceHistoryService } from 'src/app/services/invoice-history.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-invoice-modal',
  templateUrl: './send-invoice-modal.component.html',
  styleUrls: ['./send-invoice-modal.component.less']
})
export class SendInvoiceModalComponent implements OnInit {

  toEmail : string;
  @Input() invoice : InvoiceHistoryModel;
  @ViewChild('sendInvoiceForm', {}) ngForm: NgForm;
  constructor(public readonly modalService: NgbModal, private invoiceService: InvoiceHistoryService, private toast: ToastrService) {
    this.toEmail = "";
  }

  ngOnInit() {

  }

  public cancel(): void {
    this.modalService.dismissAll();
  }

  public send(): void {
    console.log(this.toEmail);
    console.log(this.invoice);
    this.invoiceService.emailInvoice(this.toEmail, this.invoice.invoiceNumber.toString()).subscribe(res => {
      this.toast.info('Invoice emailed!');
      this.modalService.dismissAll();
    },
    err => this.toast.error('An error occured when emailing the invoice.', '', { closeButton: true, disableTimeOut: true }));
  }

}
